import materialTheme from "./material";
import grayscaleTheme from "./grayscale";

export default {
  material: materialTheme,
  grayscale: grayscaleTheme
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/victory-core/es/victory-theme/victory-theme.js
// module id = 213
// module chunks = 0